import styled from '@emotion/styled'

import { colors, palette } from '../constants'

interface IRadioInputProps {
  disabled: boolean
  invalid: boolean
}

export const RadioInput = styled.input<IRadioInputProps>`
  appearance: none;
  background-color: ${palette.white};
  border: 1px solid ${({ invalid }) => (invalid ? colors.border.error : colors.border.default)};
  border-radius: 50%;
  cursor: pointer;
  outline: none;
  width: 23px;
  height: 23px;

  &:checked:before {
    background-color: ${({ disabled }) => (disabled ? palette.lightGray : palette.skyBlue2)};
    border-radius: 50%;
    content: '';
    display: block;
    width: 17px;
    height: 17px;
    margin: 2px auto;
  }

  &:disabled {
    border-color: ${colors.border.disabled};
    cursor: default;
  }
`
